<template>
  <mtd-table
    :data="list"
    height="100%"
  >
    <mtd-table-column
      label="收款时间"
      fixed="left"
      width="110"
      align="center"
      :formatter="timeFormatter"
    />
    <mtd-table-column
      label="应收金额"
      align="center"
      width="110"
      :formatter="moneyFormatter('receiveAmount')"
    />
    <mtd-table-column
      label="扣税金额"
      align="center"
      width="110"
      :formatter="moneyFormatter('taxAmount')"
    />
    <mtd-table-column
      label="实收金额"
      align="center"
      width="110"
      :formatter="moneyFormatter('receiptAmount')"
    />
    <mtd-table-column
      label="账户id"
      align="center"
      width="200"
      prop="walletId"
    />
    <mtd-table-column
      label="状态"
      align="center"
      width="110"
      :formatter="statusFormatter"
    />
  </mtd-table>
</template>

<script>

import ActivityApi from '@/api/activity';
import { getPayStatusDesc } from '@/constants/activity';
import STATUS from '@/constants/status';
import { formatTimestamp } from '@/util/filter';

export default {
  name: 'PaidFlow',
  data() {
    return {
      list: [],
    };
  },
  created() {
    const { customerId, activityId } = this.$route.query;
    this.getActivityGTVDetail(customerId, activityId);
  },
  methods: {
    async getActivityGTVDetail(customerId, activityId) {
      try {
        this.$dialog.loading.show();
        const { code, data } = await ActivityApi.getActivityGTVDetail(customerId, activityId);
        if (code === STATUS.SUCCESS) {
          this.list = data || [];
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.$dialog.loading.hide();
      }
    },
    timeFormatter(row) {
      const time = row.paidTime;
      return formatTimestamp(time, 'yyyy-MM-dd hh:mm:ss');
    },
    moneyFormatter(key) {
      return (row) => `${row[key]}元`;
    },
    statusFormatter(row) {
      const status = row.payStatus;
      return getPayStatusDesc(status);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
